// extracted by mini-css-extract-plugin
export default {"banner_searc":"banner_banner_searc__gpcSK","banner_search":"banner_banner_search__M-flp","banner_heading":"banner_banner_heading__MW5O6","banner_sec":"banner_banner_sec__c5n8E"};